"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceReviewReportSchema = exports.ReviewReportStatusSchema = exports.TenantSellerStatsSchema = exports.SELLER_TIER_MULTIPLIER = exports.SellerTierSchema = exports.DEFAULT_RANKING_WEIGHTS = exports.MarketplaceRankingWeightsSchema = void 0;
const zod_1 = require("zod");
/** Per-marketplace ranking weights (owner-tunable). Defaults from O15/UNIFIED-MODEL §5.3. */
exports.MarketplaceRankingWeightsSchema = zod_1.z.object({
    wDistance: zod_1.z.number(),
    wReview: zod_1.z.number(),
    wPrice: zod_1.z.number(),
    wStock: zod_1.z.number(),
});
exports.DEFAULT_RANKING_WEIGHTS = {
    wDistance: 0.4,
    wReview: 0.35,
    wPrice: 0.15,
    wStock: 0.1,
};
exports.SellerTierSchema = zod_1.z.enum([
    'new',
    'standard',
    'trusted',
    'top',
    'suspended',
]);
/** tier → ranking multiplier (O15 Phase 2c). */
exports.SELLER_TIER_MULTIPLIER = {
    new: 1.1, // temporary new-seller boost
    standard: 1.0,
    trusted: 1.05,
    top: 1.15,
    suspended: 0,
};
/** Per-seller aggregate, scoped per marketplace. */
exports.TenantSellerStatsSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    marketplaceId: zod_1.z.string(),
    sellerAvgReview: zod_1.z.number(),
    sellerReviewCount: zod_1.z.number(),
    sellerTier: exports.SellerTierSchema,
});
/** Review report (owner-adjudicated). */
exports.ReviewReportStatusSchema = zod_1.z.enum(['open', 'kept', 'removed']);
exports.MarketplaceReviewReportSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string(),
    reviewId: zod_1.z.string(),
    reportedBy: zod_1.z.string(),
    reason: zod_1.z.enum(['spam', 'offensive', 'off_topic', 'fake', 'other']),
    detail: zod_1.z.string().optional(),
    status: exports.ReviewReportStatusSchema,
    adjudicatedBy: zod_1.z.string().optional(), // = OWNER user id
    adjudicatedAt: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
});
//# sourceMappingURL=marketplace-review.schema.js.map